module.exports = __webpack_public_path__ + "static/img/buying_five.1a2b4eed.jpg";